// extracted by mini-css-extract-plugin
export default {"scroll-box":"ScrollContainer_scroll-box__PvdEy"};